import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=0deff95e&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=0deff95e&prod&lang=css"
import style1 from "./vip.vue?vue&type=style&index=1&id=0deff95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deff95e",
  null
  
)

export default component.exports